import styled from "styled-components"

export const BellBtnContainer = styled.button<{
  width?: string
  height?: string
}>`
  width: ${({ width }) => width || "24px"};
  height: ${({ height }) => height || "24px"};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  aspect-ratio: 1/1;
  background-color: transparent;
  outline: none;
  border: none;
  cursor: pointer;
`
export const BellBtnIcon = styled.svg``
